var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotinterested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500325 17.5031H0.500363L0.500325 17.4969C0.486462 15.261 0.916627 13.0446 1.76587 10.9762C2.61512 8.90785 3.86656 7.02865 5.4476 5.4476C7.02865 3.86655 8.90785 2.61512 10.9762 1.76587C13.0446 0.916626 15.261 0.486462 17.4969 0.500366L17.5031 0.500324C19.739 0.486462 21.9554 0.916626 24.0238 1.76587C26.0922 2.61512 27.9714 3.86655 29.5524 5.4476C31.1334 7.02865 32.3849 8.90785 33.2341 10.9762C34.0834 13.0446 34.5135 15.261 34.4996 17.4969L34.4997 17.5031C34.5135 19.739 34.0834 21.9554 33.2341 24.0238C32.3849 26.0922 31.1334 27.9714 29.5524 29.5524C27.9714 31.1334 26.0922 32.3849 24.0238 33.2341C21.9554 34.0834 19.739 34.5135 17.5031 34.4997V34.4996L17.4969 34.4997C15.261 34.5135 13.0446 34.0834 10.9762 33.2341C8.90785 32.3849 7.02865 31.1334 5.4476 29.5524C3.86656 27.9714 2.61512 26.0922 1.76587 24.0238C0.916627 21.9554 0.486462 19.739 0.500325 17.5031ZM26.6034 11.0474L26.9569 10.6939L26.6034 10.3403L24.6597 8.39661L24.3061 8.04308L23.9526 8.3966L8.39663 23.9513L8.04305 24.3049L8.39661 24.6584L10.3416 26.6034L10.6951 26.957L11.0487 26.6034L26.6034 11.0474Z",
    fill: "#FFEA32",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotinterested);
export default __webpack_public_path__ + "static/media/not interested.c749b6a65568b01df4c9c8cf139a5dd4.svg";
export { ForwardRef as ReactComponent };